import React, { Component } from "react";
import { getItem } from "../../services/itemService";
import TableTitle from "../common/tableTitle";
import { Table, Button } from "semantic-ui-react";
import BlockUi from "react-block-ui";

class SupplierItemDetail extends Component {
  state = {
    item: { category: {} },
  };

  async getItemDetail() {
    try {
      this.setState({ blocking: true });
      const itemId = this.props.match.params.id;
      const { data: item } = await getItem(itemId);

      this.setState({ item, blocking: false });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.getItemDetail();
    this.setState({ blocking: false });
  }

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <div className="order-detail">
          <h1 className="container__heading">Item Detail</h1>
          <Button
            className="btn btn--secondary"
            onClick={() => this.props.history.push("/items")}
          >
            Back
          </Button>

          <div className="card order-detial">
            <div className="order-detial__content">
              <div className="grid grid--1x2 order-detial__item">
                <span>Name</span>
                <span>{this.state.item.name}</span>
              </div>
              <div className="grid grid--1x2 order-detial__item">
                <span>Code</span>
                <span>{this.state.item.code}</span>
              </div>
              <div className="grid grid--1x2 order-detial__item">
                <span>Category</span>
                <span>{this.state.item.category.name}</span>
              </div>

              <div className="grid grid--1x2 order-detial__item">
                <span>Stock</span>
                <span>{this.state.item.stock}</span>
              </div>

              <div className="grid grid--1x2 order-detial__item">
                <span>Threshold</span>
                <span>{this.state.item.threshold}</span>
              </div>
            </div>
          </div>
        </div>
      </BlockUi>
    );
  }
}

export default SupplierItemDetail;
